import { render, staticRenderFns } from "./CloseBlock.vue?vue&type=template&id=1e618114"
import script from "./CloseBlock.vue?vue&type=script&lang=js"
export * from "./CloseBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports